<template>
  <div class="page page__list">
    <search-bar
      @search="requestList"
      name="ve_name,ve_buyername"
      placeholder="输入采购员、供应商名称进行查找"
      ref="searchBar"
    />
    <div class="filter-bar" @click="selectYear">
      <span>
        年度 {{ params.year }}
        <i class="caret"></i>
      </span>
    </div>
    <scroll-list @refresh="requestList">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="(item, index) in result"
        :key="index"
        :to="{name: 'PurchaseApcheckByYear', params: {item}}"
      >
        <div class="weui-cell__bd">
          <p>{{item.vy_vend_name}}</p>
          <p class="list-item-muted">{{item.vy_vend_code}}</p>
          <p class="list-item-muted">{{item.ve_buyername}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.vy_end }}</p>
          <p>{{item.vy_currency}}</p>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{result.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";

export default {
  components: {
    SearchBar,
    ScrollList,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(!vm.params.year) vm.params.year = new Date().getFullYear()
      vm.requestList();
    });
  },
  data() {
    return {
      listUrl: "/api/purchase/purchaseBill/listByYear",
      params: {
        vendid: null,
        vendname: "",
        year: null,
        currency: "",
        page: 1,
        start: 0,
        limit: 25,        
      },
      result: []
    };
  },
  methods: {
    requestList() {
      var me = this;
      let searchBar = me.$refs.searchBar;
      let keyword = searchBar && searchBar.keyword;

      const params = {
        year: me.params.year,
      };
      if (keyword) {
        params.condition = JSON.stringify([
          {
            type: "condition",
            value:
              "(vendor.ve_name like '%" +
              keyword +
              "%' or vendor.ve_buyername like '%" +
              keyword +
              "%')",
          },
        ]);
      }
      me.$ajax({
        url: me.listUrl,
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
        } else {
          me.$router.push({
            name: "Error",
            params: res,
          });
        }
      });
    },
    selectYear() {
      var me = this,
        year = new Date().getFullYear(),
        years = []
      for (let i = year - 20, len = year + 20; i <= len; i++) {
          years.push({
              value: i,
              label: i
          });
      }
      me.$weui.picker(
        years,
        {
          title: "选择年份",
          onConfirm: function (r) {
            me.params.year = r[0].value
            me.requestList()
          },
        }
      );
    },
  }
}
</script>

<style scoped>
.filter-bar {
  background: var(--weui-BG-2);
  position: relative;
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
}
.filter-bar span {
  margin: 0 auto;
}
</style>